package one.healthium.onboarding.ui.user_binding

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Immutable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import one.healthium.domain.user.UserModel
import one.healthium.domain.user.models.bindPlaceholderValues
import one.healthium.onboarding.domain.models.GenderText
import org.koin.compose.koinInject


@Composable
fun UserProvider(content: @Composable UserScope.() -> Unit) {
    val userViewModel = koinInject<UserViewModel>()
    val state by userViewModel.state.collectAsState()

    val safeState = state
    if (safeState != null) {
        val scope = remember(safeState) {
            UserScopeImpl(
                user = safeState.user,
                isMetric = safeState.isMetric,
            )
        }
        scope.content()
    }
}

@Immutable
internal class UserScopeImpl(
    override val user: UserModel,
    override val isMetric: Boolean,
) : UserScope {
    @Composable
    override fun String.bindUserPlaceholders(): String {
        var value by remember { mutableStateOf("") }

        LaunchedEffect(this) {
            value = user.profile.bindPlaceholderValues(this@bindUserPlaceholders, isMetric)
        }

        return value
    }

    override fun GenderText.bindGenderValue(): String {
        return this.value(user.profile.gender)
    }
}

@Immutable
interface UserScope {
    val user: UserModel
    val isMetric: Boolean

    @Composable
    fun String.bindUserPlaceholders(): String
    fun GenderText.bindGenderValue(): String
}
